<template>
  <div class="travelAgencyList-page">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="input-box">
        <img src="../../assets/travelAgency/ic_search.png"
              alt
              class="search-icon" />
        <input style
                type="text"
                placeholder="搜索旅行社名称或者统一社会信用代码"
                class="search-input"
                v-model="inputValue"
                @input="onInputChange" />
      </div>
      <div class="search-btn" @click="onTapSearch">查询</div>
    </div>
    <!-- 分割线 -->
    <div class="separator"></div>
    <div v-if="isSearching">
      <!-- 无结果 -->
      <div v-if="showNoResult" class="no-result-box">
        <img class="icon" src="../../assets/travelAgency/icon_no_result.png" alt="">
        <p class="title">没有相关旅行社</p>
      </div>
      <!-- 搜索列表 -->
      <van-list
        v-else
        v-model="searchLoading"
        :finished="searchFinished"
        finished-text="没有更多了"
        @load="searchLoadMore"
      >
        <div v-for="(item, index) in searchListData" :key="index">
          <listCell :item="item" @onTapCell="toDetail"></listCell>
        </div>
      </van-list>
    </div>
    <div v-else>
      <!-- 区域 -->
      <div class="area-box">
        <p class="title" @click="showCityPicker = true">{{ areaName }}</p>
        <img src="../../assets/travelAgency/ic_jiantou_down1.png"
            alt
            class="down-icon"
        />
      </div>
      <!-- 状态 -->
      <van-sticky>
        <div class="state-box">
          <div :class="selectedState==item.value?  'state-item selected' : 'state-item'"
            v-for="(item, index) in stateList"
            :key="index"
            @click="onTapSelectState(item)">
            <p :class="selectedState==item.value? 'state-name name-selected':'state-name'">{{ item.name }}</p>
          </div>
        </div>
      </van-sticky>
      
      <!-- 筛选条件 -->
      <div class="filter-box">
        <div class="filter-item" @click="showStatePicker = true">
          <p v-if="isOptionSelected(reviewStateOptionList) == false" class="title">信息审核状态</p>
          <p v-else class="title option">{{ buildSelectedOptionName(reviewStateOptionList) }}</p>
          <img src="../../assets/travelAgency/ic_jiantou_down1.png"
              alt
              class="down-icon"
              />
        </div>
        <div class="filter-item" @click="showSupervisePicker = true">
          <p v-if="isOptionSelected(superviseOptionList) == false" class="title">监管情况</p>
          <p v-else class="title option">{{ buildSelectedOptionName(superviseOptionList) }}</p>
          <img src="../../assets/travelAgency/ic_jiantou_down1.png"
              alt
              class="down-icon"
              />
        </div>
        <div class="filter-item" @click="showMorePicker = true">
          <p v-if="isOptionSelected(moreOptionList) == false" class="title">更多筛选</p>
          <p v-else class="title option">{{ buildSelectedOptionName(moreOptionList) }}</p>
          <div v-if="isOptionSelected(moreOptionList)" class="count">{{ buildSelectedOptionCount(moreOptionList) }}</div>
          <img src="../../assets/travelAgency/ic_jiantou_down1.png"
              alt
              class="down-icon"
              />
        </div>
      </div>
      <!-- 列表 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-for="(item, index) in listData" :key="index">
          <listCell :item="item" @onTapCell="toDetail"></listCell>
        </div>
      </van-list>
    </div>
    <!-- 信息审核状态弹窗 -->
    <van-popup v-model="showStatePicker"
               round
               position="bottom">
      <optionPicker :optionList="reviewStateOptionList" @onConfirm="onStatePickerConfirm" @onClose="showStatePicker = false"></optionPicker>
    </van-popup>
    <!-- 监管情况弹窗 -->
    <van-popup v-model="showSupervisePicker"
               round
               position="bottom">
      <optionPicker :optionList="superviseOptionList" @onConfirm="onSupervisePickerConfirm" @onClose="showSupervisePicker = false"></optionPicker>
    </van-popup>
    <!-- 更多筛选弹窗 -->
    <van-popup v-model="showMorePicker"
               round
               position="bottom">
      <optionPicker :optionList="moreOptionList" @onConfirm="onMorePickerConfirm" @onClose="showMorePicker = false"></optionPicker>
    </van-popup>
    <!-- 所属区域选择弹窗 -->
    <van-popup v-model="showCityPicker"
               round
               position="bottom">
      <cityPicker :cityTreeList="cityTree" :selectedArea="selectedArea" @onConfirm="onCityPickerConfirm" @onClose="showCityPicker = false"></cityPicker>
    </van-popup>
  </div>
</template>

<script>
    import api from '../../service/modules/travel';
    import optionPicker from './components/option-picker.vue';
    import cityPicker from './components/city-picker.vue';
    import listCell from './components/list-cell.vue';
    import { Sticky } from 'vant';
    import Vue from 'vue';
    Vue.use(Sticky);
    export default {
        name: 'TravelAgencyListNew',
        components: { optionPicker, cityPicker, listCell, Sticky },
        data () {
            return {
                areaName: '',
                stateList: [
                    {
                        name: '全部',
                        value: null
                    },
                    {
                        name: '正常',
                        value: 1
                    },
                    {
                        name: '撤销',
                        value: 4
                    },
                    {
                        name: '吊销',
                        value: 2
                    },
                    {
                        name: '注销',
                        value: 3
                    }
                ],
                reviewStateOptionList: [
                    {
                        name: '平台审核状态',
                        selectedValue: null,
                        selectedName: '',
                        values: [
                            {
                                name: '全部',
                                value: null
                            },
                            {
                                name: '待审核',
                                value: 1
                            },
                            {
                                name: '审核通过',
                                value: 3
                            }
                        ]
                    }
                ],
                superviseOptionList: [
                    {
                        name: '监管情况',
                        selectedValue: null,
                        values: [
                            {
                                name: '全部',
                                value: null
                            },
                            {
                                name: '重点关注',
                                value: 'supervise'
                            },
                            {
                                name: '黑名单监管',
                                value: 'blacklist'
                            }
                        ]
                    }
                ],
                moreOptionList: [
                    {
                        name: '旅行社类型',
                        selectedValue: null,
                        values: [
                            {
                                name: '全部',
                                value: null
                            },
                            {
                                name: '总社',
                                value: 1
                            },
                            {
                                name: '分社',
                                value: 2
                            },
                            {
                                name: '网点',
                                value: 3
                            }
                        ]
                    },
                    {
                        name: '注册情况',
                        selectedValue: null,
                        values: [
                            {
                                name: '全部',
                                value: null
                            },
                            {
                                name: '已注册',
                                value: true
                            },
                            {
                                name: '未注册',
                                value: false
                            }
                        ]
                    }
                ],

                showStatePicker: false,
                showSupervisePicker: false,
                showMorePicker: false,
                showCityPicker: false,
                selectedState: null,
                loading: false,
                finished: false,
                pagination: { total: 0, current_page: 0, page_size: 0 },
                showNoResult: false,
                // 城市树
                cityTree: [],
                selectedArea: { parent:{ txId:'' }, child:{ txId:'' } },
                listData: [],
                // 搜索相关
                inputValue: '',
                isSearching: false,
                searchLoading: false,
                searchFinished: false,
                searchPagination: { total: 0, current_page: 0, page_size: 0 },
                searchListData: []
            }
        },
        mounted () {
          this.fetchCityTree()
          if (this.$route.query.state) {
            // 经营情况
            this.selectedState = this.$route.query.state
          }
          if (this.$route.query.supervise) {
            // 监管情况
            this.superviseOptionList[0].selectedValue = this.$route.query.supervise
          }
          if (this.$route.query.review){
            // 审核情况
            this.reviewStateOptionList[0].selectedValue = this.$route.query.review
          }
          if (this.$route.query.isParent) {
            // 旅行社类型
            this.moreOptionList[0].selectedValue = this.$route.query.isParent
          }
          if (this.$route.query.register) {
            // 注册情况
            this.moreOptionList[1].selectedValue = this.$route.query.register === 'true'
          }

          // 区域
          if (this.$route.query.cityId) {
            this.selectedArea.child.txId = this.$route.query.cityId
          }
          if (this.$route.query.cityName) {
            this.selectedArea.child.shortName = this.$route.query.cityName
          }
          console.log('selected child =', this.selectedArea.child)
        },
        beforeRouteLeave(to, from, next) {
          const routerArr = ['/travelAgency/info'] //去这些界面我需要缓存
          if (!routerArr.includes(to.path)) {
          // 不在缓存列表中，从cachedViews缓存列表中移除
            this.$store.commit('refund/DEL_CACHED_VIEW', from)
          } else {
            this.$store.commit('refund/ADD_CACHED_VIEW', from)
          }
          next()
        },
        methods: {
            // 网络请求

            // 获取城市列表
            fetchCityTree () {
              api.cityTree({area: ["530000"]}).then(res => {
                if (res.ret === 0) {
                  this.cityTree = res.data
                  this.buildCityTreeData(this.cityTree)
                  console.log('city tree = ', this.cityTree)
                  if (this.selectedArea.child.txId.length < 1 ) {
                    // 没有前置参数 默认选中第一个
                    this.selectedArea.parent = this.cityTree[0]
                    this.selectedArea.child = this.selectedArea.parent.children[0]
                  } else {
                    // 有前置区域参数 由于只有一个txId 需要先找到父级
                    this.findParentArea()
                  }
                  this.buildDisplayAreaName()
                }
              })
            },
            // 把父节点自身加入子级列表作为选项
            buildCityTreeData(data) {
              for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let needAddChild = false;
                if (element.code === '530000') {
                  // 云南省 加入自己
                  needAddChild = true
                }
                if (element.children != null && element.children.length > 0) {
                  // 非区县 加入自己
                  needAddChild = true
                }
                if (needAddChild) {
                  var copiedElement = {
                    code: element.code,
                    name: element.name,
                    allName: element.allName,
                    shortName: '全部',
                    txId: element.txId,
                    txPid: element.txPid,
                    txType: element.txType
                  }
                  element.children.unshift(copiedElement)
                  this.buildCityTreeData(element)
                }
              }
            },
            // 构建需要显示的区域范围名称
            buildDisplayAreaName () {
              if (this.selectedArea.parent.txId == this.selectedArea.child.txId) {
                // 说明选择了‘全部’ 范围是父级整个范围 直接显示父级
                this.areaName = this.selectedArea.parent.shortName
              } else {
                this.areaName = this.selectedArea.child.shortName
              }
            },
            // 从子级区域找到父级区域
            findParentArea () {
              if (this.selectedArea.child.txId.length < 1) {
                return
              }

              for (let parentIdx = 0; parentIdx < this.cityTree.length; parentIdx++) {
                const parent = this.cityTree[parentIdx];
                for (let childIdx = 0; childIdx < parent.children.length; childIdx++) {
                  const child = parent.children[childIdx];
                  if (child.txId == this.selectedArea.child.txId) {
                    // 找到父级
                    this.selectedArea.parent = parent
                    return
                  }
                }
                
              }
            },
            buildSelectedOptionName (optionList) {
              if (optionList.length == 1) {
                // 只有一组选项
                let optionData = optionList[0]
                for (let index = 0; index < optionData.values.length; index++) {
                  const element = optionData.values[index];
                  if (optionData.selectedValue == element.value) {
                    return element.name
                  }
                }
              } else {
                // 多组选项
                var name = ''
                for (let index = 0; index < optionList.length; index++) {
                  const element = optionList[index];
                  if (element.selectedValue != null) {
                    if (name.length > 0) {
                      // 只要name已经被赋值就可以停了 只需要显示"已选项名称"+"..."
                      break
                    }
                    for (let idx = 0; idx < element.values.length; idx++) {
                      const valueItem  = element.values[idx];
                      if (element.selectedValue == valueItem.value) {
                        name = name + valueItem.name
                        break
                      }
                    }
                  }
                }
                return name + '...'
              }
            },

            buildSelectedOptionCount (optionList) {
              var count = 0
              for (let index = 0; index < optionList.length; index++) {
                const element = optionList[index];
                if (element.selectedValue != null) {
                  count ++
                }
              }
              return count
            },

            isOptionSelected (optionList) {
              for (let index = 0; index < optionList.length; index++) {
                const element = optionList[index];
                if (element.selectedValue != null) {
                  return true
                }
              }
              return false
            },

            // 获取列表数据
            fetchTravelList () {
                api
                    .travelList({
                        p: parseInt(this.pagination.current_page) + 1,
                        pageSize: 20, 
                        city: this.selectedArea.child.txId,
                        type: this.superviseOptionList[0].selectedValue,
                        travelStatus: this.selectedState,
                        isParent: this.moreOptionList[0].selectedValue,
                        state: this.reviewStateOptionList[0].selectedValue,
                        register: this.moreOptionList[1].selectedValue
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.listData = [...this.listData, ...res.data.list];
                            this.pagination = res.data.pagination;
                            this.loading = false;
                            if (this.pagination.current_page >= Math.ceil(this.pagination.total / this.pagination.page_size)) {
                                this.finished = true;
                            }
                        }
                    });
            },

            // 加载更多
            loadMore () {
              this.fetchTravelList()
            },

            // 搜索（数据独立于列表接口，但本质一样）
            fetchSearchTravelList () {
              this.showNoResult = false
              api.travelList({
                p:parseInt(this.searchPagination.current_page) + 1,
                pageSize: 20,
                queryPar: this.inputValue, 
              }).then(res => {
                if (res.ret === 0) {
                  this.searchListData = [...this.searchListData, ...res.data.list]
                  this.searchPagination = res.data.pagination
                  this.searchLoading = false
                  if (this.searchPagination.current_page >= Math.ceil(this.searchPagination.total / this.searchPagination.page_size)) {
                    this.searchFinished = true
                  }
                  if (this.searchFinished && this.searchListData.length == 0) {
                    this.showNoResult = true
                  }
                }
              })
            },

            searchLoadMore () {
              this.fetchSearchTravelList ()
            },

            resetParams () {
              this.pagination = { total: 0, current_page: 0, page_size: 0 }
              this.listData = []
              this.loading = true
              this.finished = false
            },

            resetSearchParams () {
              this.searchPagination = { total: 0, current_page: 0, page_size: 0 }
              this.searchListData = []
              this.searchLoading = true
              this.searchFinished = false
              console.log('search list =', this.searchListData)
            },

            // 事件
            // 点击许可证状态
            onTapSelectState (state) {
                console.log('select state')
                this.selectedState = state.value
                this.resetParams()
                this.fetchTravelList()
            },
            // 信息审核状态选择
            onStatePickerConfirm () {
                this.showStatePicker = false
                // network
                this.resetParams()
                this.fetchTravelList()
            },
            onSupervisePickerConfirm () {
                this.showSupervisePicker = false
                // network
                this.resetParams()
                this.fetchTravelList()
            },
            onMorePickerConfirm () {
                this.showMorePicker = false
                // network
                this.resetParams()
                this.fetchTravelList()
            },
            onCityPickerConfirm (selectedArea) {
              // network
              console.log('selectedArea area = ', selectedArea)
              this.selectedArea = selectedArea
              this.showCityPicker = false
              this.buildDisplayAreaName()
              this.resetParams()
              this.fetchTravelList()
            },
            // 搜索栏输入
            onInputChange (e) {
              if (e.target.value) {
                  this.inputValue = this.inputValue.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
              }
              if (this.inputValue.length <= 0) {
                this.isSearching = false
              }
            },
            // 点击搜索/查询
            onTapSearch () {
              this.isSearching = true
              this.resetSearchParams ()
              this.fetchSearchTravelList ()
              
            },
            // 跳转旅行社详情
            toDetail(item) {
              console.log('agency id =',item.id)
              this.$router.push({ path: '/travelAgency/info', query: { id: item.id } })
            }

        }
    }
</script>

<style scoped lang="less">
@vv: 3.75vw;
.travelAgencyList-page {
  width: 100%;
  min-height: 100%;
  background: #f0f2f5;
  // 搜索栏
  .search-bar {
    background-color: #fff;
    display: flex;
    align-items: center;
    height: 56 /@vv;
    padding: 12 /@vv;
    .input-box {
      flex: 1;
      height: 100%;
      padding-left: 8 /@vv;
      padding-right: 8 /@vv;
      display: flex;
      align-items: center;
      background-color: #f2f3f5;
      border-radius: 4 /@vv;
      .search-icon {
        width: 14 /@vv;
        height: 14 /@vv;
      }
      .search-input {
        flex: 1;
        background-color: #f2f3f5;
      }
    }
    .search-btn {
      margin-left: 8 /@vv;
      width: 60 /@vv;
      height: 32 /@vv;
      border-radius: 4 /@vv;
      background-color: #36b374;
      font-size: 12 / @vv;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      text-align: center;
      line-height: 32 /@vv;
    }
  }
  // 无结果
  .no-result-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 180px;
    .icon {
      width: 64px;
      height: 64px;
    }
    .title {
      margin-top: 10px;
      font-size: 14px;
      color: #54565c;
    }
  }
  // 分割线
  .separator {
    height: 1px;
    background-color: #edeff2;
    width: 100%;
  }
  .area-box {
    background-color: #fff;
    display: flex;
    align-items: center;
    padding-left: 12/@vv;
    padding-top: 10/@vv;
    .title {
      font-size: 16 /@vv;
      font-weight: 600;
      color: #1e2226
    }
    .down-icon {
      margin-left: 3.5 /@vv;
      width: 6 / @vv;
      height: 4 / @vv;
    }
  }
  .state-box {
    background-color: #fff;
    padding: 10/@vv 12/@vv;
    display: flex;
    justify-content: space-between;
    .state-item {
      width: 64 /@vv;
      height: 30 /@vv;
      border: #c8c9cc solid 1px;
      border-radius: 2 /@vv;
      display: flex;
      align-items: center;
      justify-content: center;
      .state-name {
        font-size: 13 /@vv;
        color: #1e2226;
        text-align: center;
      }
      .name-selected {
        color: #36b374;
      }
    }
    .selected {
      border: #36b374 solid 1px;
    }
  }

  // 筛选
  .filter-box {
    background-color: #f0f2f5;
    display: flex;
    justify-content: space-between;
    padding: 12 /@vv;
    .filter-item {
      display: flex;
      align-items: center;
      .title {
        font-size: 14 /@vv;
        font-weight: 400;
        color: #54565c;
      }
      .option {
        font-weight: 500;
        color: #36b374;
      }
      .count {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #36b374;
        font-size: 10/@vv;
        color: #fff;
        width: 14/@vv;
        height: 14/@vv;
        border-radius: 14/@vv;
      }
      .down-icon {
        margin-left: 3.5 /@vv;
        width: 6 / @vv;
        height: 4 / @vv;
      }
    }
  }
}
</style>
